<form autocomplete="off" [formGroup]="fileUploadForm" novalidate>
  <div class="form-group">
    <label for="cert-file">{{'SIGNINGHUB.Certificate (.P12)' | translate }}</label>
    <div class="input-group">
      <input #certificateUpload formControlName="file" id="cert-file" type="file" class="form-control"
        style="display: none;" accept=".p12, .pfx" (change)="onFileChange($event)">
      <input [attr.disabled]="true" formControlName="fileName" class="form-control" id="file-upload-name">
      <div class="input-group-append">
        <button class="btn btn-outline-secondary" (click)="certificateUpload.click()">
          <i class="fa fa-upload" aria-hidden="true"></i>
        </button>
      </div>
    </div>
  </div>
  <ng-container *ngIf="file.value">
    <div class="form-group">
      <label for="cert-password">{{'Password' | translate }}</label>
      <input type="password" class="form-control" formControlName="password" id="cert-password">
      <button class="btn btn-danger mt-1" (click)="onGetPKCS12Slot()">{{'SIGNINGHUB.View Slot' | translate }}</button>
    </div>
  </ng-container>
  <div class="form-group" *ngIf="pkcs12slots.length">
    <label for="cert-slot">{{'SIGNINGHUB.Certificate slot' | translate }}</label>
    <select class="form-control" id="cert-slot" formControlName="slot" (change)="onSlotChange()">
      <option value="" disabled selected>{{'Please select' | translate }}</option>
      <option value="{{ pkcs12slot }}" *ngFor="let pkcs12slot of pkcs12slots">
        {{ pkcs12slot }}</option>
    </select>
    <div class="text-danger" *ngIf="slot.errors && (slot.dirty || slot.touched)">
      <div *ngIf="slot.errors.required">{{'ERROR.selectCertificateSlot' | translate }}</div>
    </div>
  </div>
</form>

<div *ngIf="isLoading | async">
  <app-loader></app-loader>
</div>